// extracted by mini-css-extract-plugin
export default {"detail":"DataDetail_detail__+8FbY","title":"DataDetail_title__erXYd","author":"DataDetail_author__A3u1L"};